<template>
  <highcharts
    :constructor-type="'stockChart'"
    class="chart"
    :options="chartOpt"
  ></highcharts>
</template>


<script>
// import { Line } from 'vue-chartjs';
// import Chart from 'chart.js';
import jalali from "moment-jalaali";

export default {
  props: ["model", "def"],
  data() {
		return {
      series: [],
      categories: []
		}
	},
  computed: {
      chartOpt() {
        const threeDay = 260000000
        const oneMonth = 4717440000

        return {
          chart: {
            style: {
              fontFamily: 'IranYekanNum'
            }
          },
          legend: {
            enabled: true,
            rtl: true,
            verticalAlign: 'top',
          },
          navigator: {
              xAxis: {
                labels: {
                  formatter: function() {
                    return (jalali(this.value).format("jYYYY/jMM"))
                  }
                }
              }
          },
          xAxis: {
            ordinal: false,
            minRange: threeDay,
            min: Date.now() - oneMonth,
            max: Date.now(),
            labels: {
              formatter: function() {
                return (jalali(this.value).format("jYYYY/jMM/jDD"))
              }
            }
          },
          plotOptions: {
            series: {
                showInNavigator: true
            }
          },
          rangeSelector: {
              enabled: false,
              selected: 1,
              inputEnabled: false
          },
          tooltip: {
            shared: true,
            crosshairs: true,
            borderRadius: 10,
            useHTML: true,
            formatter: function() {
              var s = "<div style='text-align: center'><span>" + jalali(this.x).format("jYYYY/jMM/jDD") + "</span><br>"
              this.points.map(point => {
                s += `${point.series.name} : <b>${point.y}</b><br>`
              })
              s += "</div>"
              return s;
            }
          },
          series: this.series
      }
    }
  },
  mounted () {
    const labelField = this.def.graphUnitProp?.name.split(".").pop();
    const generateRandomColor = () => {
      const letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color + "80";
    }
    let array = []
    this.model.sort(function(a,b){
      return new Date(a.CalcDate) - new Date(b.CalcDate)
    })    
    this.model.map( instance => {
      array.push( (instance[labelField]))
    });
    
    const labelname = this.def.properties.filter( p => p.name !== labelField).map( p => p.name)
    labelname.map( Label => {
      let instance = {
        name : this.$t(this.def.properties.find( p => p.name === Label)),
        color: generateRandomColor(),
        data : [],
      }
      this.model.map( (i, index) => {
        // this.categories.push(new Date(array[index]).toLocaleDateString('fa'))
        instance.data.push([Number(new Date(array[index].substring(0, 10))), i[Label]])
      })
      this.series.push(instance)
    })
  }
}
</script>

<style>
.css {
  background: rgba(9, 95, 240, 0.05);
}

/* Dark mode for Highcharts */
.theme--dark .chart .highcharts-background {
  fill: #1e1e1e !important;
}

.theme--dark .chart .highcharts-plot-background {
  fill: #1e1e1e !important;
}

.theme--dark .chart .highcharts-title,
.theme--dark .chart .highcharts-subtitle {
  fill: #ffffff !important;
}

.theme--dark .chart .highcharts-axis-title,
.theme--dark .chart .highcharts-axis-labels text {
  fill: #e0e0e0 !important;
}

.theme--dark .chart .highcharts-grid-line {
  stroke: #444 !important;
}

.theme--dark .chart .highcharts-xaxis-grid-line,
.theme--dark .chart .highcharts-yaxis-grid-line {
  stroke: #444 !important;
}

.theme--dark .chart .highcharts-legend-item text {
  fill: #fff !important;
}

.theme--dark .chart .highcharts-tooltip text {
  fill: #fff !important;
}

.theme--dark .chart .highcharts-tooltip-box {
  fill: #333 !important;
  stroke: #666 !important;
}

.theme--dark .chart .highcharts-navigator mask {
  fill: #333 !important;
}

.theme--dark .chart .highcharts-navigator-outline {
  stroke: #777 !important;
}

.theme--dark .chart .highcharts-navigator-series path {
  stroke: #bbb !important;
}

.theme--dark .chart .highcharts-range-selector,
.theme--dark .chart .highcharts-range-input {
  background: #222 !important;
  color: #fff !important;
}

.theme--dark .chart .highcharts-button text {
  fill: #fff !important;
}

.theme--dark .chart .highcharts-scrollbar-button {
  stroke: #aaa !important;
}

.theme--dark .chart .highcharts-crosshair {
  stroke: #888
  }
</style>